import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./CookieConsent.css";
import {
  getConsentCookie,
  onCookieSettingsRequested,
  setConsentCookie,
} from "./cookieConsentStorage";

const CookieConsent = () => {
  const [accepted, setAccepted] = useState(() => getConsentCookie() === "true");

  useEffect(() => onCookieSettingsRequested(() => setAccepted(false)), []);

  const handleAccept = () => {
    setConsentCookie();
    setAccepted(true);
  };

  if (accepted) return null;

  return (
    <div className="cookie-consent">
      <p className="cookie-consent-text">
        Ta strona korzysta z plików cookie, aby zapewnić prawidłowe działanie
        strony internetowej, formularza kontaktowego oraz zabezpieczenia
        reCAPTCHA. Szczegóły znajdziesz w{" "}
        <Link to="/polityka-cookies" className="cookie-consent-link">
          polityce cookies
        </Link>
        .
      </p>
      <div className="cookie-consent-actions">
        <button
          type="button"
          className="btn btn-success cookie-consent-btn"
          onClick={handleAccept}
        >
          Akceptuję
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;
